export default __webpack_public_path__ + "static/media/bgMob.244419fc.png";